<div *ngIf="user">
  <div class="row">
    <div class="col">
      <div class="form-group form-inline">
        <input class="form-control" type="text" [formControl]="searchTermControl" placeholder="Rechercher" />
      </div>
    </div>
    <div class="col">
      <ngb-pagination (pageChange)="onPageChange($event)" [page]="page" [pageSize]="pageSize"
        [collectionSize]="itemsCount"></ngb-pagination>
    </div>
    <div class="col d-flex justify-content-end">
      <button class="btn btn-link" (click)="add()" *ngIf="user.isStaff">
        <i class="fas fa-plus"></i> Ajouter une nouvelle session
      </button>
      <button class="btn btn-link" (click)="add()" *ngIf="!user.isStaff && user.isExamCenterBoss">
        <i class="fas fa-plus"></i> Planifier une nouvelle session
      </button>
    </div>
  </div>
  <div class="row mb-2">
    <div class="col">
      <div class="d-flex flex-wrap" style="gap: 0.5rem;" role="group">
        <button type="button"
                class="btn btn-sm rounded-pill"
                style="white-space: nowrap;"
                [class.btn-primary]="filterControl.value === 'all'"
                [class.btn-outline-secondary]="filterControl.value !== 'all'"
                (click)="setFilter('all')">
          Toutes ({{ statusCounts.total }})
        </button>
        <button type="button"
                class="btn btn-sm rounded-pill"
                style="white-space: nowrap;"
                [class.btn-secondary]="filterControl.value === 'terminated'"
                [class.btn-outline-secondary]="filterControl.value !== 'terminated'"
                (click)="setFilter('terminated')">
          Terminées ({{ statusCounts.terminated }})
        </button>
        <button type="button"
                class="btn btn-sm rounded-pill"
                style="white-space: nowrap;"
                [class.btn-info]="filterControl.value === 'planned'"
                [class.btn-outline-secondary]="filterControl.value !== 'planned'"
                (click)="setFilter('planned')">
          Planifiées ({{ statusCounts.planned }})
        </button>
      </div>
    </div>
  </div>
</div>

<app-loading-overlay [active]="loading">
  <table class="table table-striped" *ngIf="user">
    <thead>
      <tr>
        <ng-container>
          <th scope="col" *ngIf="
              user.isStaff ||
              user.isExamCenterBoss ||
              user.isSupervisor ||
              user.isCorrector
            ">

          </th>
          <th scope="col" *ngIf="
              user.isStaff ||
              user.isExamCenterBoss ||
              user.isSupervisor ||
              user.isCorrector
            ">
            Statut
          </th>
          <th scope="col" *ngIf="
              user.isStaff ||
              user.isExamCenterBoss ||
              user.isSupervisor ||
              user.isCorrector
            ">
            Code
          </th>
          <th scope="col" *ngIf="
              user.isStaff ||
              user.isExamCenterBoss ||
              user.isSupervisor ||
              user.isCorrector
            ">
            Date & heure prévue
          </th>
          <th scope="col" *ngIf="user.isStaff || user.isSupervisor">
            Centre d'examen
          </th>
          <th scope="col" *ngIf="user.isStaff || user.isExamCenterBoss">
            Superviseur
          </th>
          <th scope="col" *ngIf="user.isStaff || user.isExamCenterBoss || user.isSupervisor">
            Supervision confirmée le
          </th>
          <th scope="col" *ngIf="user.isStaff">Correcteurs</th>
          <th scope="col" *ngIf="user.isStaff || user.isCorrector">
            Correction confirmée le
          </th>
          <th scope="col" *ngIf="
              user.isStaff ||
              user.isExamCenterBoss
            ">
            Inscriptions
          </th>
          <th scope="col" *ngIf="
              user.isStaff ||
              user.isExamCenterBoss ||
              user.isSupervisor ||
              user.isCorrector
            ">
            Succès
          </th>
          <th scope="col" *ngIf="user.isCorrector || user.isStaff || user.isSupervisor || user.isExamCenterBoss">
            <i class="fas fa-comment"> </i>
          </th>
          <th scope="col" *ngIf="user.isStaff || user.isExamCenterBoss || user.isSupervisor">
            Actions
          </th>
        </ng-container>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let session of examSessions; index as i">
        <ng-container>
          <td *ngIf="
              user.isStaff ||
              user.isExamCenterBoss ||
              user.isSupervisor ||
              user.isCorrector
            ">
            <i *ngIf="session.zoomLink" class="fas fa-laptop"></i>
            <i *ngIf="!session.zoomLink" class="fas fa-school"></i>
          </td>
          <td *ngIf="
              user.isStaff ||
              user.isExamCenterBoss ||
              user.isSupervisor ||
              user.isCorrector
            ">
            <span class="badge" [ngClass]="session.displayStatusClass">{{ session.displayStatus }}</span>
          </td>
          <td *ngIf="
              user.isStaff ||
              user.isExamCenterBoss ||
              user.isSupervisor ||
              user.isCorrector
            ">
            <ngb-highlight [result]="session.code" [term]="searchTermControl.value"></ngb-highlight>
          </td>
          <td *ngIf="
              user.isStaff ||
              user.isExamCenterBoss ||
              user.isSupervisor ||
              user.isCorrector
            ">
            {{ session.date | date: "dd/MM/yyyy HH:mm" }}<span *ngIf="session.convocationTime"><br>
              Convocation à {{ session.convocationTime }}</span>
          </td>
          <td *ngIf="user.isStaff || user.isSupervisor">
            <ngb-highlight [result]="session.center.nom" [term]="searchTermControl.value"></ngb-highlight>
          </td>
          <td *ngIf="user.isStaff || user.isExamCenterBoss">
            <ng-container *ngIf="!session.supervisor">
              <span class="text-secondary">En attente d'attribution</span>
            </ng-container>
            <ng-container *ngIf="session.supervisor">
              <ngb-highlight [result]="session.supervisor.fullName" [term]="searchTermControl.value">
              </ngb-highlight>
            </ng-container>
          </td>
          <td *ngIf="user.isStaff || user.isExamCenterBoss || user.isSupervisor">
            <span *ngIf="session.supervisorConfirmed">{{
              session.supervisorConfirmed | date: "dd/MM/yyyy"
              }}</span>
            <ng-container *ngIf="!session.supervisorConfirmed">
              <span class="text-danger" *ngIf="!user.isSupervisor">Non confirmé</span>
              <span class="btn-assign text-secondary" *ngIf="user.isSupervisor"
                (click)="confirmSupervisorAttendance(session)">Confirmer ma présence</span>
            </ng-container>
          </td>
          <td *ngIf="user.isStaff">
            <ng-container *ngIf="!session.correcteur && !session.correcteur2">
              <span class="text-secondary"> En attente d'attribution </span>
            </ng-container>
            <ng-container *ngIf="session.correcteur && !session.correcteur2">
              <ngb-highlight [result]="session.correcteur.fullName" [term]="searchTermControl.value">
              </ngb-highlight>
            </ng-container>
            <ng-container *ngIf="session.correcteur && session.correcteur2">
              Principal :
              <ngb-highlight [result]="session.correcteur.fullName" [term]="searchTermControl.value">
              </ngb-highlight><br />
            </ng-container>
            <ng-container *ngIf="session.correcteur2">
              Suppléant :
              <ngb-highlight [result]="session.correcteur2.fullName" [term]="searchTermControl.value">
              </ngb-highlight>
            </ng-container>
          </td>
          <td *ngIf="user.isStaff">
            <span *ngIf="session.correctorConfirmed && !session.correcteur2">{{
              session.correctorConfirmed | date: "dd/MM/yyyy"
              }}</span>
            <span *ngIf="session.correctorConfirmed && session.correcteur2">Prncipal : {{ session.correctorConfirmed |
              date:
              "dd/MM/yyyy" }}<br /></span>
            <span *ngIf="session.correcteur2 && session.corrector2Confirmed">Suppléant : {{ session.corrector2Confirmed
              | date:
              "dd/MM/yyyy" }}</span>
            <ng-container *ngIf="!session.correcteur2 && !session.correctorConfirmed">
              <span class="text-danger">Non confirmé</span>
            </ng-container>
            <ng-container *ngIf="session.correcteur2 && !session.correctorConfirmed">
              <span class="text-danger">Principal non confirmé</span><br />
            </ng-container>
            <ng-container *ngIf="session.correcteur2 && !session.corrector2Confirmed">
              <span class="text-danger">Suppléant non confirmé</span>
            </ng-container>
          </td>

          <td *ngIf="user.isCorrector && user.id == session.correcteur?.id">
            <span *ngIf="session.correctorConfirmed">{{
              session.correctorConfirmed | date: "dd/MM/yyyy"
              }} (Principal)</span>
            <ng-container *ngIf="!session.correctorConfirmed">
              <span class="btn-assign text-secondary" (click)="confirmCorrectorAttendance(session)">Confirmer ma
                présence en tant que correcteur principal</span>
            </ng-container>
          </td>

          <td *ngIf="user.isCorrector && user.id == session.correcteur2?.id">
            <span *ngIf="session.corrector2Confirmed">{{
              session.corrector2Confirmed | date: "dd/MM/yyyy"
              }} (Suppléant)</span>
            <ng-container *ngIf="!session.corrector2Confirmed">
              <span class="btn-assign text-secondary" (click)="confirmCorrectorAttendance(session)">Confirmer ma
                présence en tant que correcteur suppléant</span>
            </ng-container>
          </td>

          <td *ngIf="
              user.isCorrector &&
              user.id != session.correcteur?.id &&
              user.id != session.correcteur2?.id
            ">
            <span class="text-secondary">Non concerné</span>
          </td>

          <td *ngIf="
              user.isStaff ||
              user.isExamCenterBoss
            ">
            <div class="session-filling btn-assign" (click)="goToPreregistrations(session)"
              [ngbTooltip]="fillingTooltip" container="body">
              <div class="progress session-filling__bar">
                <div class="progress-bar session-filling__seg--confirmed" *ngIf="session.pctConfirmed > 0"
                  [style.width.%]="session.pctConfirmed"></div>
                <div class="progress-bar session-filling__seg--unconfirmed" *ngIf="session.pctUnconfirmed > 0"
                  [style.width.%]="session.pctUnconfirmed"></div>
                <div class="progress-bar session-filling__seg--unvalidated" *ngIf="session.pctUnvalidated > 0"
                  [style.width.%]="session.pctUnvalidated"></div>
              </div>
              <div class="session-filling__legend text-secondary">
                <span [class.session-filling__line--confirmed]="session.nbConfirmedAttendances > 0">
                  <i class="session-filling__chip session-filling__seg--confirmed"></i>
                  {{ session.nbConfirmedAttendances }} confirmée{{ session.nbConfirmedAttendances > 1 ? "s" : "" }}
                </span>
                <span [class.session-filling__line--unconfirmed]="session.nbUnconfirmedAttendances > 0">
                  <i class="session-filling__chip session-filling__seg--unconfirmed"></i>
                  {{ session.nbUnconfirmedAttendances }} non confirmée{{ session.nbUnconfirmedAttendances > 1 ? "s" : ""
                  }}
                </span>
                <span [class.session-filling__line--unvalidated]="session.nbUnvalidatedPreregistrations > 0">
                  <i class="session-filling__chip session-filling__seg--unvalidated"></i>
                  {{ session.nbUnvalidatedPreregistrations }} non vérifiée{{ session.nbUnvalidatedPreregistrations > 1 ?
                  "s" : "" }}
                </span>
                <span *ngIf="session.hasCapacity">
                  <i class="session-filling__chip session-filling__seg--remaining"></i>
                  {{ session.nbRemainingSeats }} place{{ session.nbRemainingSeats > 1 ? "s" : "" }} restante{{
                  session.nbRemainingSeats > 1 ? "s" : "" }}
                </span>
              </div>
              <div class="session-filling__overbooking" *ngIf="session.nbOverbooking > 0">
                &#9888; Surbooking ({{ session.nbOverbooking }} ticket{{ session.nbOverbooking > 1 ? "s" : "" }})
              </div>
            </div>

            <ng-template #fillingTooltip>
              <div class="text-left">
                <div>
                  {{ session.nbConfirmedAttendances }} participation{{ session.nbConfirmedAttendances > 1 ? "s" : "" }}
                  confirmée{{ session.nbConfirmedAttendances > 1 ? "s" : "" }}
                </div>
                <div>
                  {{ session.nbUnconfirmedAttendances }} participation{{ session.nbUnconfirmedAttendances > 1 ? "s" : ""
                  }} non confirmée{{ session.nbUnconfirmedAttendances > 1 ? "s" : "" }}
                </div>
                <div>
                  {{ session.nbUnvalidatedPreregistrations }} préinscription{{ session.nbUnvalidatedPreregistrations > 1
                  ? "s" : "" }} non vérifiée{{ session.nbUnvalidatedPreregistrations > 1 ? "s" : "" }}
                </div>
                <div *ngIf="session.hasCapacity">
                  {{ session.nbRemainingSeats }} place{{ session.nbRemainingSeats > 1 ? "s" : "" }} restante{{
                  session.nbRemainingSeats > 1 ? "s" : "" }} sur {{ session.nbMaxCandidates }}
                </div>
                <div *ngIf="!session.hasCapacity">Capacité non définie</div>
                <div class="mt-1">{{ session.nbToConvoke }} à convoquer</div>
                <div>{{ session.nbToFollowUp }} à relancer</div>
              </div>
            </ng-template>
          </td>

          <td *ngIf="
              user.isStaff ||
              user.isExamCenterBoss ||
              user.isSupervisor ||
              user.isCorrector
            ">
            <div>
              <app-success-pie [succeeded]="session.nbSuccessExams"
                               [failed]="session.nbFailedExams"
                               [pending]="session.nbAwaitingValidationExams"
                               [tooltip]="session.examsSummary"></app-success-pie>
              <span *ngIf="session.nbPassedExams > 0 && session.successRate >= 0.5" class="text-success"
                [ngbTooltip]="session.examsSummary" container="body"
                tooltipClass="success-tooltip">{{ session.successRate | percent }}</span>
              <span *ngIf="session.nbPassedExams > 0 && session.successRate < 0.5" class="text-danger"
                [ngbTooltip]="session.examsSummary" container="body"
                tooltipClass="success-tooltip">{{ session.successRate | percent }}</span>
            </div>
            <div *ngIf="session.nbPassedExams + session.nbAwaitingValidationExams > 0"
              class="session-success__legend text-secondary btn-assign"
              (click)="goToTickets(session)"
              [ngbTooltip]="session.examsSummary" container="body"
              tooltipClass="success-tooltip">
              <span [class.text-success]="session.nbSuccessExams > 0">
                {{ session.nbSuccessExams }} succès
              </span>
              <span [class.text-danger]="session.nbFailedExams > 0">
                {{ session.nbFailedExams }} échec{{ session.nbFailedExams > 1 ? "s" : "" }}
              </span>
              <span>
                {{ session.nbAwaitingValidationExams }} à valider
              </span>
            </div>
          </td>

          <!-- Comments -->

          <td *ngIf="
              user.isStaff ||
              user.isSupervisor ||
              user.isCorrector ||
              user.isExamCenterBoss
            ">
            <button class="btn btn-link" style="
                display: flex;
                justify-content: center;
                align-items: center;
              " (click)="openSessionCommentsModal(session)">
              <i class="fas fa-comment" style="margin-right: 5px"></i>
              {{ session.comments.length }}
            </button>
          </td>

          <td *ngIf="user.isStaff || user.isExamCenterBoss || user.isSupervisor">
            <div style="display: flex; flex-direction: column;">
              <button *ngIf="user.isStaff || (user.isExamCenterBoss && session.center.boss_id == user.id)"
                [disabled]="session.wasOpen" class="btn btn-link" (click)="edit(session)" style="margin-right: 5px">
                <i class="fas fa-edit"></i>
                Modifier
              </button>
              <button *ngIf="user.isStaff || (user.isExamCenterBoss && session.center.boss_id == user.id)"
                [disabled]="session.status === 'incident'" class="btn btn-link" (click)="reportIncident(session)"
                style="margin-right: 5px">
                <i class="fas fa-exclamation-triangle"></i>
                Signaler
              </button>
              <button *ngIf="user.isStaff || (user.isExamCenterBoss && session.center.boss_id == user.id)"
                [disabled]="session.wasOpen || session.exams.length > 0" class="btn btn-link" (click)="delete(session)"
                style="margin-right: 5px">
                <i class="fas fa-trash"></i>
                Supprimer
              </button>
              <button *ngIf="user.isSupervisor" class="btn btn-link" (click)="supervise(session)">
                <i class="fas fa-tasks"></i>
                Supervision
              </button>
              <button *ngIf="user.isStaff" [disabled]="!session.wasOpen" class="btn btn-link"
                (click)="downloadXml(session)">
                Exporter en xml
              </button>
              <button *ngIf="user.isStaff" [disabled]="!session.wasOpen" class="btn btn-link"
                (click)="minutePdf(session)">
                Procès-verbal
              </button>
            </div>
          </td>
        </ng-container>
      </tr>
    </tbody>
  </table>
</app-loading-overlay>